import { DefaultNotFoundAppError, PageError } from "@repo/ui";
import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
} from "@tanstack/react-router";
import { DatadogError } from "~/components/DatadogError";

function RootComponent() {
  return (
    <>
      <HeadContent />
      <Outlet />
    </>
  );
}

export const Route = createRootRouteWithContext()({
  component: RootComponent,
  errorComponent: (props) => (
    <DatadogError
      errorProps={props}
      render={(p) => <PageError error={p.error} />}
    />
  ),
  notFoundComponent: DefaultNotFoundAppError,
});
